import { apiClient } from '@/api/client';
import type {
  AcceptInvitationResponse,
  InviteResponse,
  OrgInfo,
  OrgMember,
  OrgMembersResponse,
  OrgRole,
} from '@/types/orgMembers';

const headers = { 'Cache-Control': 'no-cache', Pragma: 'no-cache' };
const id = (value: string) => encodeURIComponent(value);

export const OrgMembersService = {
  organization(): Promise<OrgInfo> {
    return apiClient.request('GET', '/api/v1/org', undefined, headers);
  },
  members(): Promise<OrgMembersResponse> {
    return apiClient.request('GET', '/api/v1/org/members', undefined, headers);
  },
  changeRole(memberId: string, role: OrgRole): Promise<OrgMember> {
    return apiClient.request(
      'PATCH',
      `/api/v1/org/members/${id(memberId)}/role`,
      { role },
      headers
    );
  },
  remove(memberId: string): Promise<void> {
    return apiClient.request(
      'DELETE',
      `/api/v1/org/members/${id(memberId)}`,
      undefined,
      headers
    );
  },
  invite(email: string, role: OrgRole): Promise<InviteResponse> {
    return apiClient.request(
      'POST',
      '/api/v1/org/invitations',
      { email, role },
      headers
    );
  },
  revokeInvitation(invitationId: string): Promise<void> {
    return apiClient.request(
      'DELETE',
      `/api/v1/org/invitations/${id(invitationId)}`,
      undefined,
      headers
    );
  },
  acceptInvitation(invitationId: string): Promise<AcceptInvitationResponse> {
    return apiClient.request(
      'POST',
      `/api/v1/org/invitations/${id(invitationId)}/accept`,
      undefined,
      headers
    );
  },
};
